/**
 * Modifier and option constants for TextToolSettings.
 * Extracted to keep TextToolSettings.tsx under the file size limit.
 */

export const MODELS = [
  // Google Gemini
  { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash' },
  { id: 'gemini-3-flash-preview', name: 'Gemini 3 Flash' },
  { id: 'gemini-3-pro-preview', name: 'Gemini 3 Pro (2.5x)' },
  { id: 'gemini-2.0-flash-exp', name: 'Gemini 2.0 Flash' },
  // OpenAI (Welle 2a)
  { id: 'gpt-4o-mini', name: 'GPT-4o mini (0.5x)' },
  { id: 'gpt-4o', name: 'GPT-4o (3.0x)' },
  { id: 'gpt-4.1', name: 'GPT-4.1 (3.0x)' },
];

export const OUTPUT_FORMATS = [
  { id: 'plain', labelKey: 'formatPlain' },
  { id: 'markdown', labelKey: 'formatMarkdown' },
  { id: 'html_full', labelKey: 'formatHtmlFull' },
  { id: 'html_amazon', labelKey: 'formatHtmlAmazon' },
  { id: 'json', labelKey: 'formatJson' },
];

export const WRITING_STYLES = [
  { id: 'precise', labelKey: 'stylePrecise', icon: '🎯' },
  { id: 'balanced', labelKey: 'styleBalanced', icon: '⚖️' },
  { id: 'creative', labelKey: 'styleCreative', icon: '✨' },
  { id: 'bold', labelKey: 'styleBold', icon: '🔥' },
];

export const TEXT_STYLES = [
  { id: 'faktenbasiert', labelKey: 'modifiers.style.faktenbasiert' },
  { id: 'emotional_storytelling', labelKey: 'modifiers.style.emotional' },
  { id: 'verkaufspsychologisch', labelKey: 'modifiers.style.verkaufspsychologisch' },
  { id: 'seo', labelKey: 'modifiers.style.seo' },
];

export const LENGTH_BUCKETS = [
  { id: 'kurz', labelKey: 'modifiers.length.kurz' },
  { id: 'standard', labelKey: 'modifiers.length.standard' },
  { id: 'lang', labelKey: 'modifiers.length.lang' },
  { id: 'xl', labelKey: 'modifiers.length.xl' },
];

export const READING_LEVELS = [
  { id: 'allgemein_verstaendlich', labelKey: 'modifiers.reading.allgemein' },
  { id: 'wie_ein_fachmagazin', labelKey: 'modifiers.reading.fachmagazin' },
  { id: 'akademisch', labelKey: 'modifiers.reading.akademisch' },
];

export const GOALS = [
  { id: 'standard', labelKey: 'modifiers.goal.standard' },
  { id: 'kuerzen', labelKey: 'modifiers.goal.kuerzen' },
  { id: 'erweitern', labelKey: 'modifiers.goal.erweitern' },
  { id: 'verbessern', labelKey: 'modifiers.goal.verbessern' },
];

export const TOOLS_SUPPORTING_GOAL = new Set(['text_rewrite', 'text_custom']);
